import { ClassThemeProvider } from '@class-ui/theme';
import { useParams, useLocation } from 'react-router-dom';

import { PlaybackContent } from '../components/video/PlaybackContent';
import { SocketProvider } from '../context/SocketContext';
import { localStorageKeys } from '../localStorageKeys';

const VideoPlayback = () => {
    const { tabId, meetingId } = useParams<any>();
    const { search } = useLocation();

    const params = new URLSearchParams(search);
    const userUuid = window.localStorage.getItem(localStorageKeys.userUuid) ?? undefined;
    const classSessionUuid = params.get('class_session_uuid');
    const sourceZoomId = params.get('source_zoom_id') ?? undefined;

    if (!classSessionUuid) {
        console.error('[VideoPlayback] Missing required query parameters - class_session_uuid is not provided.');
        return <></>;
    }

    const playbackInfo = {
        tabId,
        meetingId,
        classSessionUuid,
        sourceZoomId
    };

    const tabData = params.get('tab_data');
    let parsedTabData: object | undefined;
    if (tabData) {
        parsedTabData = JSON.parse(tabData);
    } else if (!userUuid) {
        console.error(
            '[VideoPlayback] Either tab_data needs to be provided in query parameters, or user_uuid available in local storage.'
        );
        return <></>;
    }

    return (
        <SocketProvider>
            <ClassThemeProvider theme="dark">
                <PlaybackContent playbackInfo={playbackInfo} userUuid={userUuid} tabData={parsedTabData} />
            </ClassThemeProvider>
        </SocketProvider>
    );
};

export default VideoPlayback;
